import React from "react";
import { Controller } from "react-hook-form";
import Form from "../../Form";
import { SquarePlusIcon, TextInput } from "djinn-components";
import FormFieldErrors from "../../Form/FormFieldErrors";
import { useBus } from "react-bus";
import { useNavigate } from "react-router-dom";

const CreateSiteForm: React.FC = () => {
  const navigate = useNavigate();
  const bus = useBus();
  const getDefaults = () => {
    return {
      title: "",
      // type: "startup",
      // duration: "annual",
    };
  };

  const onSubmit = async ({ project }: { project: string }) => {
    // window.location.replace(checkout_url);
    // await fetchUser();
    navigate(`/${project}`);
  };

  return (
    <Form
      getDefaults={getDefaults}
      onCompleted={onSubmit}
      buttonTitle="Continue"
      endpoint="sites"
      method="post"
      showReset={false}
      render={({ errors, control, watch }) => {
        return (
          <>
            <div className="flex flex-col items-center justify-center max-w-sm mx-auto text-center mb-6">
              <div className="mx-auto flex items-center justify-center h-10 w-10">
                <SquarePlusIcon />
              </div>
              <h3 className="text-xl text-white">Create a new site</h3>
              <div className="mt-2">
                <p className="text-sm font-light leading-5 text-gray-450">
                  Please enter a site title to get started,{" "}
                  <button
                    type="button"
                    className="hover:text-white font-bold cursor-pointer"
                    onClick={(e) => {
                      e.preventDefault();
                      bus.emit(
                        "open-help-link",
                        "guides/how-to-add-a-new-project"
                      );
                    }}
                  >
                    get help with project setup and plans
                  </button>
                </p>
              </div>
            </div>

            <div className="mb-4">
              <Controller
                name="title"
                control={control}
                defaultValue=""
                rules={{
                  required: true,
                }}
                render={({ field: { onChange, value } }: any): JSX.Element => (
                  <TextInput
                    value={value}
                    onChange={onChange}
                    invalid={!!errors.title}
                    placeholder="Enter your site title"
                  />
                )}
              />

              <FormFieldErrors
                errors={errors}
                field="title"
                requiredMessage="Your site title is required to continue"
              />
            </div>
            <div className="text-xs my-4">
              You will be started on a 30 day trial period, after which you will
              need to upgrade to one of our{" "}
              <a
                className="mt-4 text-sm font-medium hover:text-secondary"
                href="/pricing"
                target="_blank"
              >
                paid plans
              </a>
              .
            </div>
          </>
        );
      }}
    />
  );
};

export default CreateSiteForm;
